// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table[data-v-17703cf8] {\n  width: 100%;\n}\ntr[data-v-17703cf8] {\n  background: #fff;\n}\nth[data-v-17703cf8] {\n  padding: 10px 20px;\n}\nth.actions[data-v-17703cf8] {\n  width: 125px;\n}\n", ""]);
// Exports
module.exports = exports;
